<script>
    import Router from "svelte-spa-router";
    import { link, push, location } from "svelte-spa-router";
    import Toast from "./atoms/Toast.svelte";
    import IconButton from "./atoms/IconButton.svelte";
    import { getFund, searchFunds } from "./api/fund.js";
    import { toasts } from "./stores.js";
    import Dialogue from "./molecules/Dialogue.svelte";
    import { Home, Fund, Search, CreateFund, EditFund, Verify, Terms} from "./routes";

    export let params = {}

    const routes = {
        "/": Home,
        "/fund/:title?": Fund,
        "/newfund": CreateFund,
        "/editfund/:fundId?": EditFund,
        "/search": Search,
        "/verify/:fund_id?/:code?": Verify,
        "/terms": Terms,
    }

    $: editFund = false
    $: width = 0
    $: onFund = $location.substring(1,5) == "fund"
    $: large = width >= 768

    const handleEdit = () => {
        let fundId = $location.split('/').slice(-1)[0]; 
        push("/editfund/" + fundId); 
        editFund = false;
    }
</script>

<svelte:window bind:innerWidth={width}/>

<body>
    <div style="height: fit-content;">
        <div class="header">
        <div style="position: fixed; top: 0; left: 0;"class="bar bg-brand-green"></div>
            <div class="start">
        
                <a use:link={"/"}><img height="100%" width="100%" class="logo" src="https://api.plithos.fund/logo"/></a>
                <a use:link={"/"}><h1>Plithos Fund</h1></a> 
                <h4 class="beta">beta</h4>
        
            </div>
        
            {#if onFund && large}
                <button 
                    on:click={() => editFund = true}
                    class="edit b dim br2 ph3 pv2 dib white bg-brand-blue">
                    Edit this Fundraiser
                </button>
            {/if}
        
            {#if onFund && !large}
                <div on:click={() => editFund = true}>
                    <IconButton shadow icon="pencil alternate" color="white" fg="#3891FF"/>
                </div>
            {/if}
        </div>
    </div>

    {#if editFund}
        <Dialogue cancel on:okay={handleEdit} on:close={() => editFund = false}>
            <h3 style="margin-block: 0px;">Are you sure?</h3>
            <p style="font-weight: 500; margin-block: 1.2rem;">Only the owner of this Fund can edit this.</p>
        </Dialogue>
    {/if}

    <div class="spacer"/>

    <div class="page">
        <Router {routes}/>
    </div>

    <div class="toasts">
        {#each $toasts as toast}
            <Toast text={toast.text} type={toast.color}/>
        {/each}
    </div>
</body>

<style>
    .edit-ico {
        color: #3891FF;
    }
    .modal-container {
        background-color: white;
        padding: 1rem;
        border-radius: 1rem;
    }
    .modal {
        width: 100vw;
        background-color: rgba(0,0,0,0.3);
        height: 100vh;
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        left: 0;
        bottom: 0;
    }
    .edit {
        margin-right: 1rem;
    }
    .toasts {
        padding-left: 0.3rem;
        padding-bottom: 0.2rem;
        position: fixed;
        left: 0;
        bottom: 0;
    }
    .start {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .beta {
        margin-left: 0.4rem; color: #3891FF; } .subtitle {
        margin-left: 0.6rem;
    }
    .spacer {
        height: 5rem;
    }
    .page {
        padding-bottom: 5rem;
    }
    .header {
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background-color: white;
        height: 5rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #E0E0E0;
    }
    @media only screen and (min-width: 768px) {
        .page {
            display: flex;
            justify-content: center;
        }
        .header {
            padding-left: 1rem;
        }
    }
    a {
        color: inherit; /* blue colors for links too */
        text-decoration: inherit; /* no underline */
    }
    .search {
        cursor: pointer;
        color: #3891FF;
        padding-top: 4px;
        margin-right: 0.8rem;
    }
    .logo {
        height: 3.8rem;
        width: 4.2rem;
    }
    .bar {
        height: 1px;
        width: 100%;
    }
</style>
